<div class="modal-body p-0">
        <ng-container *ngIf="imageIncludeEstimateList.length > 0">
            <p class="pt-0 include text-align-center text-center">Do you want to include the images for these item(s) in the PDF?</p>
            <div class="table">
                <table>
                    <thead class="p-2">
                        <tr>
                            <th>S.no</th>
                            <th>SKU</th>
                            <th>Image</th>
                            <th>Item Name</th>
                            <th>Description</th>
                            <th>Video</th>
                            <th>Script</th>
                            <th>Charge Type</th>
                            <th>Price</th>
                            <th>Tax</th>
                            <th>Qty</th>
                            <th>Total</th>
                            <th>Inspection</th>
                            <th>Include Images</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let estimate of imageIncludeEstimateList; let i = index" class="example-box">
                            <ng-container *ngIf="!estimate.noData">
                                <td class="index-column">{{ i + 1 }}</td>
                                <td class="sku-column">{{ estimate.sku }}</td>
                                <td class="media-column">
                                    <div *ngIf="estimate?.images?.length > 1; else showSingleImage" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.images.length - 1) }}</span>
                                        <div class="image">
                                            <img [src]="estimate.images[0].link" width="28px" height="28px"
                                                class="rounded-circle">
                                        </div>
                                    </div>
                                    <ng-template #showSingleImage>
                                        <img *ngIf="estimate?.images?.length; else noMedia"
                                            [src]="estimate.images[0].link" width="28px" height="28px"
                                            class="rounded-circle">
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td>{{ estimate['itemName'] }}</td>
                                <td class="description">
                                    <div>{{ estimate['description'] }}</div>
                                </td>
                                <td>
                                    <div *ngIf="estimate?.videos?.length > 1; else showSingleVideo" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.videos.length - 1) }}</span>
                                        <div class="image">
                                            <video [src]="estimate.videos[0].link" width="28px" height="28px"
                                                class="rounded-circle"></video>
                                        </div>
                                    </div>
                                    <ng-template #showSingleVideo>
                                        <video *ngIf="estimate?.videos?.length; else noMedia"
                                            [src]="estimate.videos[0].link" width="28px" height="28px"
                                            class="rounded-circle"></video>
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td class="description">
                                    <div>{{ estimate['script'] }}</div>
                                </td>
                                <td>{{ estimate['chargeType'] }}</td>
                                <td>{{ estimate['price'] ? '$' + (estimate['price'].toFixed(2)) : '$0.00' }}</td>
                                <td>{{ estimate['tax'] ? '$' + estimate['tax'] : '$0.00' }}</td>
                                <td>{{ estimate['quantity'] }}</td>
                                <td>{{ estimate['total'] ? '$' + (estimate['total'].toFixed(2)) : '$0.00' }}</td>
                                <td>
                                    <span class="btn w-100" [ngClass]="setInspectionStatus(estimate.inspectionId)">
                                        {{ estimate.inspectionStatus || '---' }}
                                    </span>
                                </td>
                                <td>
                                    <input class="form-check-input" type="checkbox"
                                        [checked]="checkedEstimate.includes(estimate?._id)"
                                        (change)="estimateChecked(estimate?._id)" />
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
        <div class="footerSec">
            <button type="button" class="btn base-btn cancel" [mat-dialog-close]="false">Cancel</button>
            <button type="submit" class="btn base-btn submit" (click)="download()">Download</button>
        </div>
    </div>
